import React from 'react';
import AnalizeClienti from './Analize';
import { List, ListItem } from '@material-ui/core';
import SpecificComponent from '../../commons/SpecificComponent';


export default class ClientiStari extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
        listPierduti:[],
        listCastigati:[],
        listLoiali:[],
        listActivi:[]
}
    }

     componentDidMount(){
         this.getDateClienti()
    }

    getDateClienti = async()=>{

        let a = new AnalizeClienti()

        let _cP =  a.getClientiPierduti()        
      


        let _cC =  a.getClientiCastigati()  // acopera si clienti noi
      


        let _cLL =  a.clientiLoiali()
        
        

        let _cAc =  a.clientiActivi()
       

        let [cP,cC,cLL,cAc] = await Promise.all([_cP,_cC,_cLL,_cAc])

        // console.warn('clienti pierduti = ', cP)
        // console.warn('clienti castigati = ', cC)
        // console.warn('clienti loiali = ', cLL)
        // console.warn('clienti activi = ', cAc)

        this.setState({
            listPierduti:cP,
            listCastigati:cC,
            listLoiali:cLL,
            listActivi:cAc
        })
    }
     render() { 
       return (
          <div>
              
              <div>
                <h1 className='pm-title'>{this.dictionary.financiarContabil.clientiPierduti}</h1>
                {this.state.listPierduti.length === 0 && <span>{this.dictionary.financiarContabil.nuExista}</span>}
                <List>
                        {this.state.listPierduti.map((l,idx)=>{
                            return(
                               
                                 
                           
                                <ListItem key={idx} style={{textAlign:'center', justifyContent:'center'}}> 
                                    <span className='pm-title'>{l}</span>
                                </ListItem>
                            )
                        })}
                    </List>
            </div>
            
            
              <div>
                <h1 className='pm-title'>{this.dictionary.financiarContabil.clientiCastigati}</h1>
                {this.state.listCastigati.length === 0 && <span>{this.dictionary.financiarContabil.nuExista}</span>}
                <List>
                        {this.state.listCastigati.map((l,idx)=>{
                            return(
                               
                                 
                           
                                <ListItem key={idx} style={{textAlign:'center', justifyContent:'center'}}> 
                                    <span className='pm-title'>{l}</span>
                                </ListItem>
                            )
                        })}
                    </List>
            </div>
            

            
              <div>
                <h1 className='pm-title'>{this.dictionary.financiarContabil.clientiLoiali}</h1>
                {this.state.listLoiali.length === 0 && <span>{this.dictionary.financiarContabil.nuExista}</span>}
                <List>
                        {this.state.listLoiali.map((l,idx)=>{
                            return(
                               
                                 
                           
                                <ListItem key={idx} style={{textAlign:'center', justifyContent:'center'}}> 
                                    <span className='pm-title'>{l}</span>
                                </ListItem>
                            )
                        })}
                    </List>
            </div>
            

         
              <div>
                <h1 className='pm-title'>{this.dictionary.financiarContabil.clientiActivi}</h1>
                {this.state.listActivi.length === 0 && <span>{this.dictionary.financiarContabil.nuExista}</span>}
                <List>
                        {this.state.listActivi.map((l,idx)=>{
                            return(
                               
                                 
                           
                                <ListItem key={idx} style={{textAlign:'center', justifyContent:'center'}}> 
                                    <span className='pm-title'>{l.client}</span>
                                </ListItem>
                            )
                        })}
                    </List>
            </div>
            
         </div>
        );
       }
}